import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
  semiBoldFonts,
} from "../../Styles/Styles";

const Steps = () => {
  const steps = [
    {
      image: "/Images/Get-Listed-for-Free.png",
      title: "Get Listed for Free",
      description:
        "Create your account today on Listed.ky and start listing your products or services for free!",
    },
    {
      image: "/Images/Post-Your-Ad.png",
      title: "Post Your Ad",
      description:
        "Easily list your products, or services and start reaching potential customers.",
    },
    {
      image: "/Images/Customizable-Offers.png",
      title: "Customizable Offers",
      description:
        "Give your buyers the power to negotiate. Let them make offers on your items—on your terms.",
    },
    {
      image: "/Images/Boost-Your-Visibility.png",
      title: "Boost Your Visibility",
      description:
        "Stand out from the crowd and accelerate your sales by gaining more exposure on Listed.ky.",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        flexWrap: "wrap",
        gap: 4,
        mt: 15,
        mb: 15,
      }}
    >
      {steps.map((step, index) => (
        <Box key={index} sx={{ width: "100%", maxWidth: "300px" }}>
          <Card
            sx={{
              backgroundColor: "#ffffff",
              padding: "20px",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              height: "100%",
              ...cardOutline,
              ...cardHover,
            }}
          >
            {/* Number Badge */}
            <div
              style={{
                position: "absolute",
                top: "10px",
                left: "20px",
                ...semiBoldFonts,
                fontSize: "44px",
                fontWeight: "600",
                color: "var(--primary-color-bg-category-home)",
              }}
            >
              {index + 1}
            </div>

            {/* Image */}
            <img
              src={step.image}
              alt={step.title}
              style={{
                height: "170px",
                transition: "transform 0.3s ease-in-out",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.1)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            />

            {/* Card Content */}
            <CardContent sx={{ textAlign: "center" }}>
              <Typography
                variant="h6"
                sx={{
                  ...semiBoldFonts,
                  color: "#2d2d2d",
                }}
              >
                {step.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  ...fonts,
                  color: "#686868",
                  lineHeight: "1.6",
                }}
              >
                {step.description}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      ))}
    </Box>
  );
};

export default Steps;
